import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import icoPin from '../../../assets/img/ico-pin.svg';
import icoMail from '../../../assets/img/ico-mail.svg';
import Vector2 from '../../../assets/img/Vector-2.png';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';

class Canais extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"canais-atendimento"} image={"canais-atendimento"} items={null} /></ErrorBoundary>

				{/* Page description */}
				{/* <ErrorBoundary><PageDescriptionContato page={"canais-atendimento"} /></ErrorBoundary> */}
				{/* Content page */}
                <div className="_the-content pb-10">
                    <div className='container'>
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <div className="row py-10 border-bottom">
                                    <div className="col-2">
                                        <div className="ico">
                                            <img src={icoPin} alt="Ícone"/>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9">
                                        <div className="texto">
                                            <h3> Atendimento presencial </h3>
                                            <p className="mb-0">
                                                R. Conde de Linhares, 77 - Cidade Jardim, Belo Horizonte - MG</p>
                                                <p className="mb-0">
                                                Horário de atendimento: de segunda a sexta-feira, das 8 às 17 horas.

                                                <a href="" className="text-primary d-lg-none"> <br/> <br/> Veja a localização no mapa </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row py-10 border-bottom ">
                                    <div className="col-2">
                                        <div className="ico">
                                            <img src={icoMail} alt="Ícone"/>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9">
                                        <div className="texto">
                                            <h3> E-mail </h3>
                                            <p className="mb-0">
                                                atendimento@forluz.org.br
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row py-10">
                                    <div className="col-2">
                                        <div className="ico">
                                            <img src={Vector2} alt="Ícone"/>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9">
                                        <div className="texto">
                                            <h3> Central de atendimento </h3>
                                            <p className="mb-0">
                                                <strong> 0800-0909090 </strong> <br/>
                                                Horário de atendimento: de segunda a sexta-feira, das 8h30 às 17h30
                                                <br/> <br/>

                                                
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Canais;